/** Met en majuscule la première lettre de chaque mot, y compris après un tiret
 * ou une apostrophe (ex: "jean-pierre o'brien" -> "Jean-Pierre O'Brien"). */
export const titleCase = (value: string | null | undefined): string => {
  if (!value) return "";

  return value
    .toLowerCase()
    .replace(/(^|[\s'-])([a-zà-öø-ÿ])/g, (_, boundary, letter) => boundary + letter.toUpperCase());
};
